import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'

class CartButtonsBlock extends BaseComponent {
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = this.closest('cart-page')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('start-update', this.handleStartCartUpdate)
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('start-update', this.handleStartCartUpdate)
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleStartCartUpdate = (): void => {
    this.setLoading(true)
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
    this.setLoading(false)
  }

  updateByNode(node: HTMLElement): void {
    const blockId = this.getAttribute('block-id')
    const newButtonsBlock = node.querySelector(
      `cart-buttons-block[block-id="${blockId}"]`,
    )

    if (!newButtonsBlock) {
      return
    }

    const clonedNewButtonsBlock = newButtonsBlock.cloneNode(true)

    this.replaceChildren(...clonedNewButtonsBlock.childNodes)
  }

  setLoading(isLoading: boolean): void {
    const button = this.querySelector('[data-cart-page-checkout-button]')

    if (!button) {
      return
    }

    button.toggleAttribute('disabled', isLoading)
    button.classList.toggle('loading', isLoading)
  }
}

export default CartButtonsBlock
